import $ from 'jquery'

export default {
    name: 'dmp-detail',
    components: {},
    props: {
        patients: [],
        modal_toggler: Number,
        modal_title: String
    },
    data() {
        return {
            fields: [
                { key: 'no', label: 'N° dossier' },
                { key: 'nom', label: 'Nom' }, { key: 'prenom', label: 'Prénom' }, "sexe", { key: 'age', label: 'Âge' },
                { key: 'telephone', label: 'Téléphone' },
            ],

            consultation_fields: [
                { key: 'reference', label: 'Référence Bon' }, { key: 'date', label: 'Date' }, 
                { key: 'type_consultation', label: 'Type consultation' }, 
                { key: 'patient', label: 'Patient' }, "sexe", { key: 'age', label: 'Âge' },
                { key: 'telephone', label: 'Téléphone' },
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            dmp_len: 0,
            grouped_consultation_by_patient: [],
            config_to_show: 'tous',
            selected_patient: {
                patient_id: 0,
                patient: "Tous les patients"
            },
            liste_patients: [
                {
                    patient_id: 0,
                    patient: "Tous les patients"
                }
            ]
        }
    },

    watch: {
        modal_toggler() {
            this.config_to_show = 'tous'
            this.selected_patient = {
                patient_id: 0,
                patient: "Tous les patients"
            }
            this.refreshDMP()
            this.groupConsultationByPatient()
        },

        selected_patient() {
            this.showByFilter()
        }
    },

    computed: {

    },

    mounted() {
        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        refreshDMP() {
            if (this.patients) {
                this.dmp_len = this.patients.length
            }
        },

        groupConsultationByPatient() {
            console.log("Liste patients: ",this.patients);
            this.liste_patients = [
                {
                    patient_id: 0,
                    patient: "Tous les patients"
                }
            ]
            this.grouped_consultation_by_patient = []
            const tmp_grouped_patients = this.patients.groupBy('patient_id')
            for (const key in tmp_grouped_patients) {
                const tmp_grouped_consultations = tmp_grouped_patients[key].groupBy('type_consultation')

                let tmp_consultation_by_patient = []
                for (const c_key in tmp_grouped_consultations) {
                    const tmp_group = {
                        type_consultation: tmp_grouped_consultations[c_key][0].type_consultation,
                        sub_total: tmp_grouped_consultations[c_key].length
                    } 
                    tmp_consultation_by_patient.push(tmp_group)
                }

                const tmp_final_group = {
                    patient_id: tmp_grouped_patients[key][0].patient_id,
                    patient: tmp_grouped_patients[key][0].nom+' '+tmp_grouped_patients[key][0].prenom,
                    total_consultation: tmp_grouped_patients[key].length,
                    consultations: tmp_consultation_by_patient
                }

                this.grouped_consultation_by_patient.push(tmp_final_group)
                this.liste_patients.push(tmp_final_group)
            }
            
        },

        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },

        showByFilter() {
            if (this.selected_patient.patient_id == 0) {
                $('.ptn').fadeIn()
            } else {
                $('.ptn').fadeOut()

                setTimeout(() => {
                    $('#ptn'+this.selected_patient.patient_id).fadeIn()
                }, 500);
            }
            
        }
    }
}